import { Accordion, AccordionDetails, AccordionSummary, Box, FormGroup, Typography } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

import { AudienceSourceCriteria } from '../../types/AudienceSource';
import { AudienceSourceCategory } from '../../types/AudienceSourceCategory';

export type AudienceSourceFilterProps = {
    audienceSourceCategories: AudienceSourceCategory[];
    searchCriteria: AudienceSourceCriteria;
    changeSearchCriteria: (searchCriteria: AudienceSourceCriteria) => void;
};

export default function AudienceSourceFilter(props: AudienceSourceFilterProps) {
    const { audienceSourceCategories } = props;
    const { searchCriteria, changeSearchCriteria } = props;

    return (
        <FormGroup>
            {audienceSourceCategories.map((category: AudienceSourceCategory) => (
                <Box
                    key={category.id}
                    sx={{
                        borderBottomWidth: 1,
                        borderBottomColor: 'divider',
                        borderBottomStyle: 'solid',
                    }}
                >
                    <Accordion disableGutters square elevation={0}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            sx={{
                                '& .MuiAccordionSummary-content': {
                                    my: 0,
                                },
                            }}
                        >
                            <Typography variant="subtitle1">{category.name}</Typography>
                        </AccordionSummary>
                        <AccordionDetails
                            sx={{
                                height: 250,
                                overflowY: 'auto',
                            }}
                        >
                            {category.children.map((subCategory: AudienceSourceCategory) => {
                                const isSelected = searchCriteria.categories.includes(subCategory.code);
                                return (
                                    <Box
                                        key={subCategory.code}
                                        onClick={() =>
                                            changeSearchCriteria({ ...searchCriteria, categories: [subCategory.code] })
                                        }
                                        sx={{
                                            ml: 5,
                                            px: 2,
                                            py: 1,
                                            borderRadius: 2,
                                            cursor: 'pointer',
                                            backgroundColor: isSelected ? 'primary.light' : 'transparent',
                                            '&:hover': {
                                                backgroundColor: isSelected ? 'primary.light' : 'grey.100',
                                            },
                                        }}
                                    >
                                        <Typography>{subCategory.name}</Typography>
                                    </Box>
                                );
                            })}
                        </AccordionDetails>
                    </Accordion>
                </Box>
            ))}
        </FormGroup>
    );
}
